/*
 * @Author: wangqiong 2650366496@qq.com
 * @Date: 2025-09-22 16:52:59
 * @LastEditors: wangqiong 2650366496@qq.com
 * @LastEditTime: 2025-09-30 15:42:27
 * @FilePath: \hlweb2.0\src\pages\Home\index.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React from "react";
import "antd/dist/antd.css";
import Top from "../../components/common/Top";
import Footer from "../../components/common/Footer";
import FreeTrial from "../../components/FreeTrial";
import AnchorPoint from "../../components/AnchorPoint";
import ProductServices from "./ProductServices";
import Banner from "./Banner";
import BriefIntroduction from "./BriefIntroduction";
import Culture from "./Culture";
import CultureActivities from "./CultureActivities";
import Develop from "./Develop";
import { Layout } from "antd";
import actionWays from "../../redux/actions";
import { adaptation } from "../../utils/adaptation";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withTranslation } from "react-i18next";
import "../Solution/common/index.scss";
const bannerObj = {
  imgUrl: require("../../assets/images/aboutUs/banner1.png").default,
  // title: "保障房数字化管理解决方案",
  // details:
  //   "保障性住房数字化解决方案通过整合数字技术、优化管理流程、提升服务质量，有助于实现保障性住房的智能化、高效化和人性化管理，为广大群众提供更加优质的住房保障服务。",
};
const { Content } = Layout;
class AboutUs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      publicList: [],
      projectList: [],
      projectName: "",
      showScroll: false,
    };
  }
  componentDidMount = () => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    adaptation();
  };

  render() {
    const { t } = this.props;
    const anchorPointList = [
      { name: t("home.anchorPoint1"), link: "home_briefIntroduction_id" },
      { name: t("home.anchorPoint2"), link: "home_develop_id" },
      { name: t("home.anchorPoint3"), link: "home_culture_id" },
      { name: t("home.anchorPoint4"), link: "home_productSerCon_id" },
    ];
    return (
      <Layout>s
        <Top />
        {/* <ContactModel /> */}
        <Content id="contentId">
          {/* banner图 start*/}
          <Banner bannerObj={bannerObj} />
          {/* banner图 end*/}
          {/* 锚点 start*/}
          <AnchorPoint anchorPointList={anchorPointList} />
          {/* 锚点 end*/}
          {/* 公司简介 start*/}
          <BriefIntroduction />
          {/* 公司简介 end*/}
          {/* 发展历程 start*/}
          <Develop />
          {/* 发展历程 end*/}
          {/* 企业文化 start*/}
          <Culture />
          {/* 企业文化 end*/}
          {/* 文化活动 start*/}
          <CultureActivities />
          {/* 文化活动 end*/}
          {/* 产品中心 */}
          <ProductServices />
          {/* 产品中心 */}
          {/* 在线体验  start*/}
          <FreeTrial />
          {/* 在线体验  end*/}
          <Footer />
        </Content>
      </Layout>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    userLoginInfo: state.userLoginInfo,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    saveLoginInfo: (...args) => dispatch(actionWays.saveLoginInfo(...args)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(withTranslation()(AboutUs)));
